import { Col, Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const ConfirmUpdateConversionRateTabRoot = styled(Col)(
    ({ theme }) => css`
        gap: ${theme.spacing[4]};
    `,
);

export const WarningBox = styled(Row)(
    () => css`
        background: #fff3cd;
        border: 1px solid #ffc107;
        border-radius: 8px;
        padding: 16px;
        align-items: flex-start;
        gap: 12px;
    `,
);

export const WarningIcon = styled.div(
    () => css`
        width: 20px;
        height: 20px;
        background: #ffc107;
        border-radius: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 12px;
        flex-shrink: 0;
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        position: relative;

        &::before {
            content: "!";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-weight: bold;
            font-size: 12px;
        }
    `,
);

export const InfoBox = styled(Col)(
    () => css`
        background: #e6e0f2;
        border-radius: 8px;
        padding: 16px;
        gap: 12px;
    `,
);

export const ConversionInputsContainer = styled(Col)(
    ({ theme }) => css`
        gap: ${theme.spacing[4]};
    `,
);

export const InputRow = styled(Row)(
    ({ theme }) => css`
        gap: ${theme.spacing[4]};
        align-items: flex-end;
    `,
);

export const InputContainer = styled(Col)(
    ({ theme }) => css`
        flex: 1;
        gap: ${theme.spacing[2]};
    `,
);

export const InputField = styled.input(
    () => css`
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        font-size: 14px;
        color: #495057;
        background: white;

        &:focus {
            outline: none;
            border-color: #43398e;
            box-shadow: 0 0 0 2px rgba(67, 57, 142, 0.2);
        }

        &:disabled {
            background: #e9ecef;
            color: #6c757d;
            cursor: not-allowed;
        }
    `,
);

export const DisabledInputField = styled(InputField)(
    () => css`
        background: #e9ecef;
        color: #6c757d;
        cursor: not-allowed;
    `,
);

export const EditableInputField = styled.input(
    () => css`
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        font-size: 14px;
        color: #495057;
        background: white;

        &:focus {
            outline: none;
            border-color: #43398e;
            box-shadow: 0 0 0 2px rgba(67, 57, 142, 0.2);
        }

        &:hover {
            border-color: #adb5bd;
        }
    `,
);

export const RateBalanceContainer = styled.div(
    () => css`
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        font-size: 14px;
        color: #495057;
        background: #e9ecef;
        display: flex;
        align-items: center;
        min-height: 48px;
    `,
);

export const CheckboxContainer = styled(Row)(
    ({ theme }) => css`
        align-items: flex-start;
        gap: ${theme.spacing[2]};
        margin-top: ${theme.spacing[2]};
    `,
);
